@if (isVisible) {
  <div class="holiday-banner">
    <div class="holiday-banner__bar">
      <span class="holiday-banner__badge">{{ config.badge }}</span>
      <span class="holiday-banner__text">
        {{ config.message }}
        <button
          type="button"
          class="holiday-banner__link"
          aria-controls="holiday-banner-details"
          [attr.aria-expanded]="isPanelOpen"
          (click)="togglePanel()"
        >
          {{ isPanelOpen ? 'Hide details' : config.linkText }}
        </button>
      </span>
      <button
        type="button"
        class="holiday-banner__close"
        aria-label="Close banner"
        (click)="closeBanner()"
      >
        <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>

    <!-- ------------------------- Collapsible details ------------------------- -->
    <div
      id="holiday-banner-details"
      class="holiday-banner__details"
      [class.holiday-banner__details--open]="isPanelOpen"
      [attr.aria-hidden]="!isPanelOpen"
    >
      <div>
        <div class="holiday-banner__detail">
          <h4 class="holiday-banner__title">{{ config.title }}</h4>
          <p class="holiday-banner__muted">{{ config.intro }}</p>

          <dl class="holiday-banner__facts">
            @for (fact of config.facts; track fact.heading) {
              <div class="holiday-banner__fact">
                <svg
                  class="holiday-banner__icon"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  @switch (fact.icon) {
                    @case ('calendar') {
                      <rect x="3" y="5" width="18" height="16" rx="2" />
                      <path d="M16 3v4M8 3v4M3 10h18" />
                    }
                    @case ('clock') {
                      <circle cx="12" cy="12" r="9" />
                      <path d="M12 7v5l3 2" />
                    }
                    @case ('trend') {
                      <path d="M3 17l6-6 4 4 8-8" />
                      <path d="M15 7h6v6" />
                    }
                  }
                </svg>
                <dt class="holiday-banner__label">{{ fact.heading }}</dt>
                <dd class="holiday-banner__value">
                  {{ fact.value }} {{ fact.unit }}
                </dd>
                <dd class="holiday-banner__muted">{{ fact.text }}</dd>
              </div>
            }
          </dl>

          <div class="holiday-banner__foot">
            <p class="holiday-banner__muted">{{ config.outro }}</p>
            @if (config.ctaUrl) {
              <a
                class="holiday-banner__btn"
                target="_blank"
                rel="noopener"
                [href]="config.ctaUrl"
                >{{ config.ctaText }}</a
              >
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
